import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ThumbsUp"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 8.25003H15V4.50003C15.1574 3.00059 14.0694 1.65747 12.57 1.50003C12.3807 1.47753 12.1893 1.47753 12 1.50003H10.8225C10.3069 1.51416 9.86595 1.87492 9.75 2.37753V2.46753L9 7.22253L6.345 11.25H1.5V21.75H15.75C21.33 21.75 22.5 18.4875 22.5 15.75V11.25C22.6574 9.75059 21.5694 8.40747 20.07 8.25003C19.8807 8.22753 19.6893 8.22753 19.5 8.25003ZM6 20.25H3V12.75H6V20.25ZM21 15.75C21 18.8175 19.335 20.25 15.75 20.25H7.5V12.225L10.5 7.77754L11.0475 3.75004L11.1525 3.00004H12C13.08 3.00004 13.5 3.42004 13.5 4.50004V9.75004H19.5C20.58 9.75004 21 10.17 21 11.25V15.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ThumbsUp.vue"]]);
